import * as angular from 'angular';
import { StudentPreviewModalCtrl as controller } from './student-list-preview.controller';

export class StudentListPreviewModal {
  static $inject: string[] = ['SDCStore', '$mdDialog'];

  constructor(private SDCStore: any, private $mdDialog: any) {}

  openPreview(filter: any, columnKeys: string[], description: string): void {
    this.$mdDialog.show({
      locals: {
        filter,
        columnKeys,
        description,
      },
      disableParentScroll: true,
      template: require('./student-list-preview.html'),
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      controller,
      controllerAs: '$ctrl',
    });
  }
}

angular.module('nv.shared.modals').service('StudentListPreviewModal', StudentListPreviewModal);
